export default __webpack_public_path__ + "5476a845648fb22a78f6101fa13f5719.otf";